import { atom } from "~/observers/jotai";

import type { ToastDTO } from "./types";

export const toastsAtom = atom<ToastDTO[]>([]);
